import { LogLevel, log } from "../utils/log";
import { EventHandler } from "./registerEventHandler";
import { GameEvent } from "../interfaces/theos.interface";
import { postToOperator } from "./postToOperator";
import { processOutbound } from "./messageProcessor";

type Listener = EventHandler<{readonly type: GameEvent; readonly payload?: unknown}>;

const outboundMessageListeners: Listener[] = [];

export const sendGameEvent = (type: GameEvent, payload?: unknown): void =>
{
    outboundMessageListeners.forEach((handler) => {
        handler({type, payload});
    });

    const message = processOutbound(type, payload);

    if (message === undefined) {
        return;
    }

    log("Sending 🠊", LogLevel.ALL_MESSAGES, message);
    postToOperator(message);
};

/**
 * Listen to the events sent by the game.
 * The callback will receive all the events.
 */
export const registerOutBoundMessagesListener = (listener: Listener): void =>
{
    outboundMessageListeners.push(listener);
};